import { useState, useEffect } from 'react';
import '../styles/NavBar.css'
import { useNavBar } from '../../ViewModel/NavBarViewModel.js';
import { useServices } from '../../ViewModel/ServiceViewModel.js';

function NavBar({
    adminMode = false,
    isAdminLoggedIn = false,
    onAdminLogout = () => {},
}) {
    const { services = [] } = useServices();
    const [selectedServiceId, setSelectedServiceId] = useState('');
    const { isMobileMenuOpen, toggleMobileMenu, closeMobileMenu } = useNavBar();

    const navigateTo = (targetPath) => {
        if (!targetPath) return;
        if (window.location.pathname === targetPath) return;
        window.history.pushState({}, '', targetPath);
        window.dispatchEvent(new PopStateEvent('popstate'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleHomeClick = (e) => {
        e.preventDefault();
        closeMobileMenu();
        if (window.location.pathname !== '/') {
            navigateTo('/');
            return;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    
    const handleServiceSelect = (event) => {
        const value = event.target.value;
        setSelectedServiceId(value);
        if (!value) return;
        closeMobileMenu();
        navigateTo(`/tjanster/${value}`);
        setTimeout(() => setSelectedServiceId(''), 150);
    };

    useEffect(() => {
        if (selectedServiceId) return;
        // Ensure dropdown placeholder stays visible on first render
        setSelectedServiceId('');
    }, [services.length, selectedServiceId]);
    
    if (adminMode) {
        return (
            <nav className="navbar navbar-admin">
                <div className="navbar-logo">
                    <a href="/admin" onClick={(event) => {
                        event.preventDefault();
                        closeMobileMenu();
                        navigateTo('/admin');
                    }}>
                        <img src="/Images/logo.png" alt="Redovisningsbyrån logotyp" className="logo-image"/>
                    </a>
                </div>
                <div className="admin-status-wrap">
                    <button
                        type="button"
                        className="admin-back-btn"
                        onClick={(event) => {
                            event.preventDefault();
                            closeMobileMenu();
                            navigateTo('/admin');
                        }}
                    >
                        Tillbaka till admin
                    </button>
                    <span className="admin-status-badge">{isAdminLoggedIn ? 'Admin inloggad' : 'Admin'}</span>
                    <button type="button" className="admin-logout-btn" onClick={onAdminLogout}>Logga ut</button>
                </div>
            </nav>
        );
    }

    return (
        <nav className="navbar">
            {/* Logo sektion */}
            <div className="navbar-logo">
                <a href="/" onClick={(event) => {
                    event.preventDefault();
                    closeMobileMenu();
                    navigateTo('/');
                }}>
                    <img src="/Images/logo.png" alt="Redovisningsbyrån logotyp" className="logo-image"/>
                </a>
            </div>

            {/* Hamburger Menu Button */}
            <button 
                className={`hamburger ${isMobileMenuOpen ? 'active' : ''}`} 
                onClick={toggleMobileMenu}
                aria-label="Toggle navigation"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* Navigation sektion */}
            <ul className={`navbar-nav ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <li>
                    <a href="/" onClick={handleHomeClick}>STARTSIDA</a>
                </li>

                {services.length > 0 && (
                    <li className="navbar-service-dropdown">
                        <label htmlFor="navbar-service-select" className="sr-only">Välj tjänst</label>
                        <select
                            id="navbar-service-select"
                            value={selectedServiceId}
                            onChange={handleServiceSelect}
                        >
                            <option value="">VÅRA TJÄNSTER</option>
                            {services.map((service) => (
                                <option key={service.id} value={service.id}>{service.title}</option>
                            ))}
                        </select>
                    </li>
                )}

                <li>
                    <a href="/omoss" onClick={(event) => {
                        event.preventDefault();
                        closeMobileMenu();
                        navigateTo('/omoss');
                    }}>OM OSS</a>
                </li>
                <li>
                    <a href="/faq" onClick={(event) => {
                        event.preventDefault();
                        closeMobileMenu();
                        navigateTo('/faq');
                    }}>FAQ</a>
                </li>
                {/* Mobile: CTA */}
                {isMobileMenuOpen ? (
                    <li className="mobile-cta">
                        <a href="/kontakt" className="btn-contact" onClick={(event) => {
                            event.preventDefault();
                            closeMobileMenu();
                            navigateTo('/kontakt');
                        }}>KONTAKTA OSS</a>
                    </li>
                ) : (
                    <div className="navbar-cta">
                        <a href="/kontakt" className="btn-contact" onClick={(event) => {
                            event.preventDefault();
                            navigateTo('/kontakt');
                        }}>KONTAKTA OSS</a>
                    </div>
                )}
            </ul>
        </nav>
        
    );
}
export default NavBar;